import type { ScriptDef } from './types';
import { NPC_MAP } from './tables/NPCs';
import { SPECIAL_NPCS } from './tables/SpecialNpcs';

/**
 * 固定阵容信用（ScriptDef.cast 的唯一读取口，2026-10-21）。
 * 剧本表里的 cast 是「角色名 + 演员 npcId + 番位 + 角色定位」，不是 roles 里的 roleIndex 位。
 * 热度榜要演员名、奖项要角色名/档位/咖位，两边都从这里取；别处再遍历 cast 自己拼即第二把尺。
 */
export interface FixedCastCredit {
    /** 剧中角色名（奖项 %角色名% 用） */
    roleName: string;
    /** 演员名（NPCS 定稿名；无 npcId 时回退角色名） */
    actorName: string;
    npcId?: string;
    /** 角色定位（女主角/女配角…）：奖项档位与性别从这里派生 */
    roleType: string;
    billing: number;
    /** 固定咖位（资源型特殊 NPC 的 rank；无则 undefined） */
    rank?: number;
}

const warned = new Set<string>();
function warnOnce(key: string, text: string): void {
    if (warned.has(key)) return;
    warned.add(key);
    console.warn(`[cast] ${text}`);
}

export function fixedCastCredits(script: ScriptDef): FixedCastCredit[] {
    return (script.cast ?? []).map(c => {
        const npc = c.npcId ? NPC_MAP[c.npcId] : undefined;
        if (c.npcId && !npc) {
            warnOnce(`${script.id}:${c.npcId}`,
                `${script.id}《${script.name}》cast「${c.name}」的 npcId=${c.npcId} 在主表查无，演员名回退角色名`);
        }
        if (!c.roleType) {
            warnOnce(`${script.id}:${c.name}:roleType`,
                `${script.id}《${script.name}》cast「${c.name}」缺 roleType：热度榜仍显示主演，奖项不收录`);
        }
        const sp = c.npcId ? SPECIAL_NPCS.find(s => s.npcId === c.npcId) : undefined;
        return {
            roleName: c.name,
            actorName: npc?.name ?? c.name,
            npcId: c.npcId,
            roleType: c.roleType ?? '',
            billing: c.billing,
            rank: sp?.rank ?? sp?.rival?.rank,
        };
    });
}
